var _g, _g2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLimitBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 346 200",
    height: 200,
    width: 346,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEB4BC",
    d: "M130.167 100.476L137.309 93.3333L130.167 86.1904L123.024 93.3333L130.167 100.476Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEB4BC",
    d: "M79.5 20C70.6634 20 63.5 27.1634 63.5 36V40H83.5L83.5 68L99.5 84H83.5L83.5 96H63.5V164C63.5 172.837 70.6634 180 79.5 180H267.5C276.337 180 283.5 172.837 283.5 164V152H263.5V140H247.5L263.5 124V96H283.5V36C283.5 27.1634 276.337 20 267.5 20H79.5ZM233.5 73.3333V106.667H200.167L212.119 94.7143L186.833 69.4281L165.167 91.0946L114.072 40H132.928L165.167 72.2384L186.833 50.5718L221.547 85.2862L233.5 73.3333ZM146.833 166.667V120H113.5V166.667H146.833ZM200.167 140H233.5V166.667H200.167V140ZM156.833 130H190.167V166.667H156.833V130ZM130.167 76.6666C120.962 76.6666 113.5 84.1285 113.5 93.3333C113.5 102.538 120.962 110 130.167 110C139.371 110 146.833 102.538 146.833 93.3333C146.833 84.1285 139.371 76.6666 130.167 76.6666Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEB4BC",
    d: "M146.833 120H113.5V166.667H146.833V120Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEB4BC",
    d: "M233.5 140H200.167V166.667H233.5V140Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEB4BC",
    d: "M156.833 130H190.167V166.667H156.833V130Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AEB4BC",
    d: "M53.2083 79.0001V70.2918H44.5V65.7085H53.2083V57.0001H57.7917V65.7085H66.5V70.2918H57.7917V79.0001H53.2083Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEB4BC",
    d: "M83.5 40H27.5V96H83.5L83.5 84H99.5L83.5 68L83.5 40ZM55.5 84.5001C64.6127 84.5001 72 77.1128 72 68.0001C72 58.8874 64.6127 51.5001 55.5 51.5001C46.3873 51.5001 39 58.8874 39 68.0001C39 77.1128 46.3873 84.5001 55.5 84.5001Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEB4BC",
    d: "M300.536 124C300.536 129.027 296.462 133.102 291.435 133.102C286.408 133.102 282.333 129.027 282.333 124C282.333 118.974 286.408 114.899 291.435 114.899C296.462 114.899 300.536 118.974 300.536 124ZM291.435 129.5C294.472 129.5 296.935 127.038 296.935 124C296.935 120.963 294.472 118.5 291.435 118.5C288.397 118.5 285.935 120.963 285.935 124C285.935 127.038 288.397 129.5 291.435 129.5Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEB4BC",
    d: "M263.5 96H319.5V152H263.5L263.5 140H247.5L263.5 124V96ZM294.185 103.899H288.685V109.657C282.826 110.774 278.209 115.391 277.092 121.25H271.334V126.75H277.092C278.208 132.609 282.826 137.227 288.685 138.343V144.101H294.185V138.343C300.044 137.227 304.661 132.609 305.778 126.75H311.536V121.25H305.778C304.661 115.391 300.044 110.774 294.185 109.657V103.899Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0B90B",
    d: "M130.167 76.67C120.962 76.67 113.5 84.1319 113.5 93.3366C113.5 102.541 120.962 110.003 130.167 110.003C139.371 110.003 146.833 102.541 146.833 93.3366C146.833 84.1319 139.371 76.67 130.167 76.67ZM130.167 100.48L137.309 93.3367L130.167 86.1938L123.024 93.3367L130.167 100.48Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitBuy);
export default __webpack_public_path__ + "static/media/limit-buy.a54202922f055fca0a084f7cd50df2e0.svg";
export { ForwardRef as ReactComponent };